import {
  decryptData,
  getToken,
  getMachineCode,
  getEquipmentType,
  getVersionCode,
} from '@/utils/auth';

function getUploadQueryParams() {
  const hash = window.location.hash;
  const queryIndex = hash.indexOf('?');
  if (queryIndex === -1) return null;
  return Object.fromEntries(new URLSearchParams(hash.slice(queryIndex + 1)));
}

export function getUploadBaseApi() {
  const queryParams = getUploadQueryParams();
  if (!queryParams) return process.env.VUE_APP_BASE_API;
  if (queryParams.AES) {
    const str = decryptData(decodeURIComponent(queryParams.AES));
    const query = JSON.parse(str);
    return query.baseUrl || query.baseURL || process.env.VUE_APP_BASE_API;
  }
  const raw = queryParams.baseUrl || queryParams.baseURL;
  if (raw) {
    try {
      return decodeURIComponent(raw);
    } catch (error) {
      return raw;
    }
  }
  return process.env.VUE_APP_BASE_API;
}

export async function buildUploadHeaders(baseURL) {
  const headers = {
    Accept: '*/*',
    'Content-Type': undefined,
  };
  const isCustomBase = baseURL !== process.env.VUE_APP_BASE_API;
  if (isCustomBase && getToken()) {
    headers.accessToken = getToken();
    headers.equipmentType = getEquipmentType();
    headers.machineCode = getMachineCode();
    if (headers.equipmentType !== 3) {
      headers.versioncode = await getVersionCode();
    }
  }
  return headers;
}
